var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-16.94 0 474.82 474.82",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000;}")), /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2",
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pizza"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.07,88.52,133.38,326.94l16.43,29.59v0L213,470.44a8.49,8.49,0,0,0,14.86,0l212-381.92a8.49,8.49,0,0,0-2.36-10.94c-1.06-.79-26.6-19.68-66.12-38.78C334.79,21.1,278.89,0,220.47,0c-32.24,0-84.6,6.73-150.92,38.8C30,57.9,4.49,76.79,3.43,77.58A8.49,8.49,0,0,0,1.07,88.52ZM170,357.79a56.8,56.8,0,1,0-54.54-98.28L47.81,137.7C87,114.23,152.22,75.35,220.47,75.35s133.47,38.88,172.66,62.35L220.46,448.8Zm-26.63-48-19.54-35.22a39.81,39.81,0,1,1,37.8,68.12ZM19.65,87c23.28-15.76,110-70,200.82-70S398,71.2,421.29,87l-19.9,35.86C360.63,98.42,293.12,58.35,220.47,58.35S80.31,98.42,39.55,122.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212,187.58a63.86,63.86,0,1,0,63.86-63.86A63.93,63.93,0,0,0,212,187.58Zm17,0a46.86,46.86,0,1,1,46.86,46.85A46.91,46.91,0,0,1,229,187.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.39,177.58a36.31,36.31,0,1,0-36.3,36.3A36.35,36.35,0,0,0,158.39,177.58Zm-17,0a19.31,19.31,0,1,1-19.3-19.31A19.32,19.32,0,0,1,141.39,177.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.74,306a8.5,8.5,0,1,1-5.13,16.21,23,23,0,0,0-28.81,14.95,8.5,8.5,0,0,1-16.21-5.14A40,40,0,0,1,271.74,306Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.67,151.57a3.5,3.5,0,0,1-2.11,6.68,30.67,30.67,0,0,0-38.47,19.95,3.5,3.5,0,0,1-6.68-2.11A37.69,37.69,0,0,1,287.67,151.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.5,272.91A35,35,0,0,1,178,318.76a3.5,3.5,0,0,1-3.22,2.13,3.5,3.5,0,0,1-3.22-4.87,28,28,0,0,0-14.77-36.67,3.5,3.5,0,1,1,2.74-6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177,158.27a8.28,8.28,0,0,1-2.39-.35,8.49,8.49,0,0,1-5.77-10.54A15.93,15.93,0,0,0,158,127.66a8.5,8.5,0,1,1,4.76-16.32,32.93,32.93,0,0,1,22.36,40.81A8.5,8.5,0,0,1,177,158.27Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.325df9f5ca294ae0b6bed89e5f82bd14.svg";
export { ForwardRef as ReactComponent };